import React, { useEffect, useState } from "react";
import lifestyle from "../assets/articale/6.jpg";
import charlie from "../assets/charlie.webp";
import will from "../assets/will.webp";

const GradeTechnology = () => {
  const [vid, setVid] = useState(null);

  useEffect(() => {
    function replaceVidPlaceholder() {
      if (window?.clickmagick_cmc && window?.clickmagick_cmc?.vid) {
        setVid(window?.clickmagick_cmc?.vid);
      } else {
        setTimeout(replaceVidPlaceholder, 200);
      }
    }
    replaceVidPlaceholder();
  }, []);

  return (
    <>
      <div>
        <h2 className="text-2xl font-bold text-[#303030] mb-6">
          {"Introducing Herbal Tea Therapy’s “Breathe”"}
        </h2>
        <div className="relative w-full mb-6">
          <img
            src={lifestyle}
            alt="Lung diagram with surrounding bacterial images"
            className="w-full rounded-3xl border border-gray-100"
            draggable="false"
          />
        </div>
        <div className="space-y-4 text-[#303030]">
          <p>
            Herbal Tea Therapy’s{" "}
            {vid ? (
              <a
                id="cta-button"
                href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
                rel="noopener noreferrer"
              >
                <span
                  className="font-bold text-blue-600 hover:underline"
                  title="GET Herbal Tea Therapy Breathe NOW"
                >
                  {"“Breathe” "}
                </span>
              </a>
            ) : (
              <a
                id="cta-button"
                href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
                rel="noopener noreferrer"
              >
                <span
                  className="font-bold text-blue-600 hover:underline"
                  title="GET Herbal Tea Therapy Breathe NOW"
                >
                  {"“Breathe” "}
                </span>
              </a>
            )}
            {"is the first and only product on the market to utilize this "}{" "}
            <span className="font-bold">
              {"natural medical-grade technology "}
            </span>{" "}
            {
              "that not only liquefies and expels mucus from the lungs but also repairs damaged cells and tissues."
            }
          </p>
          <p className="font-bold">{"But don’t just take my word for it… "}</p>
          <p>
            {"Thousands of people around the world are using"}{" "}
            <span className="font-bold">{"“Breathe” "}</span>{" "}
            {
              "to cleanse and protect their airways, improving overall lung health and alleviating all types of respiratory diseases—from seasonal colds to chronic bronchitis, pneumonia, COPD, and asthma."
            }
          </p>
          <div className="bg-[#f0faf2] py-4">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-3">
                <img
                  src={charlie}
                  alt="Laura Foster"
                  className="w-12 h-12 object-contain"
                  draggable="false"
                />
              </div>
              <div className="text-[#303030] text-sm">
                <span className="md:text-[18px] text-[13px]">
                  {"Charlotte H."}{" "}
                  <span className="text-[#417505]">{"Verified Review |"}</span>{" "}
                </span>
              </div>
              <div className=" flex items-center gap-1 px-1 py-1 rounded-full text-sm">
                <div>{" Rating: "}</div>
                <span className="md:text-xl text-sm text-yellow-400">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
            </div>
            <div className="p-4">
              <div>
                <p className="font-bold text-xl mb-2 text-[#303030]">
                  {"I didn't think this would work.. But it did!"}
                </p>
              </div>
              <div>
                <p style={{ lineHeight: "23px" }} className="text-[#303030]">
                  {
                    "“I was skeptical, but after using Breathe, I felt a dramatic change. Within minutes, I began to clear mucus and breathe deeply for the first time in years. My sleep improved, and I feel rejuvenated!”"
                  }
                </p>
              </div>
            </div>
          </div>
          <div className="bg-[#f0faf2] py-4">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-3">
                <img
                  src={will}
                  alt="Laura Foster"
                  className="w-12 h-12 object-contain"
                  draggable="false"
                />
              </div>
              <div className="text-gray-700 text-sm">
                <span className="md:text-[18px] text-[13px]">
                  {"William B."}{" "}
                  <span className="text-[#417505]">{"Verified Review |"}</span>{" "}
                </span>
              </div>
              <div className=" flex items-center gap-1 px-1 py-1 rounded-full text-sm">
                <div>{" Rating: "}</div>
                <span className="md:text-xl text-sm text-yellow-400">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
            </div>
            <div className="p-4">
              <div>
                <p className="font-bold text-xl mb-2 text-[#303030]">
                  {"I still can't believe it, but I'm breathing freely again"}
                </p>
              </div>
              <div>
                <p style={{ lineHeight: "23px" }} className="text-[#303030]">
                  {
                    "“After quitting smoking, I struggled with persistent coughing and sinus issues. Breathe made a noticeable difference within a day, allowing me to breathe freely again and regain my sense of smell.”"
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GradeTechnology;
